import styled from 'styled-components';

export const MainContent = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 80%;
    padding: 0;
  }
`;

export const FormContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    margin: 0;
  }
`;

export const Container = styled.div`
  margin: 0 auto;
`;

export const ContentWrapper = styled.div`
  background-color: ${(props) => props.theme.colorsNew.gray.graySLight};
  display: flex;
  flex-direction: column;
  @media (min-width: ${(props) => props.theme.breakpoints.md}) {
    flex-direction: row;
    width: 100%;
  }
`;

export default ContentWrapper;
